import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { ProviderService } from './provider.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { ProviderListComponent } from './list/list.component';

import { ProviderFormComponent } from './form/form.component';
import { TooltipModule } from 'ngx-bootstrap';
import { ProviderGuard } from './provider.guard';
import { ProviderListGuard } from './provider-list.guard';
import { PartyListGuard } from './party-list.guard';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    ProviderListComponent,
    ProviderFormComponent,
    // KeysPipe,
  ],
  exports: [
    // ProviderFormComponent
  ]
})
export class ProviderModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ProviderModule,
      providers: [
        ProviderService,
        ProviderGuard,
        ProviderListGuard,
        PartyListGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/provider/provider.module.ts